import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { HtmlRenderer } from '../../components/htmlAreas/htmlRenderer';
import { LOBBY_ROOM_CHIP_CSS, RoomDisplaySecondRowContainer } from './lobbyRoomDisplay';
const TEXT_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0 5px;
  align-items: center;
  color: #444444; // some player names will have black or red coloring to differentiate from this default
  user-select: none;
`;
function getStatusMemo(playersString, isTourneyTable, numPlayersSitting) {
    if (isTourneyTable) {
        return playersString;
    }
    if (numPlayersSitting === undefined || numPlayersSitting < 1) {
        // room is "inactive" but don't display anything to this effect
        return '';
    }
    return numPlayersSitting > 1 ? `${numPlayersSitting} Playing` : `1 Sitting`;
}
export const LobbyRoomSecondRowDisplay = ({ lobbyRoom }) => {
    const statusMemo = getStatusMemo(lobbyRoom.playersString, lobbyRoom.isTourneyTable, lobbyRoom.numPlayersSitting);
    return (_jsx(RoomDisplaySecondRowContainer, { "aria-label": 'room summary', children: _jsx(Typography, { variant: 'caption', children: _jsxs("div", { css: TEXT_CSS, children: [statusMemo && _jsx(Chip, { css: LOBBY_ROOM_CHIP_CSS, label: statusMemo, size: 'small' }), _jsx(HtmlRenderer, { html: lobbyRoom.roomSummaryHtml })] }) }) }));
};
